import Align from './Align';
import CustomFontFamily from './CustomFontFamily';
import CustomFontSize from './CustomFontSize';
import CustomVariableBlot from './CustomVariableBlot';
import DividerBlot from './DividerBlot';
import EmbedlyBlot from './EmbedlyBlot';
import Font from './Font';
import Indent from './Indent';
import InlineImageBlot from './InlineImageBlot';
import LetterSpacing from './LetterSpacing';
import LineHeight from './LineHeight';
import LinkBlot from './LinkBlot';
import ListItemBlot from './ListItemBlot';
import Mention from './Mention';
import Size from './Size';

export {
  Align,
  CustomFontFamily,
  CustomFontSize,
  CustomVariableBlot,
  DividerBlot,
  EmbedlyBlot,
  Font,
  Indent,
  InlineImageBlot,
  LetterSpacing,
  LineHeight,
  LinkBlot,
  ListItemBlot,
  Mention,
  Size,
};

export const formats = [
  Align,
  CustomFontFamily,
  CustomFontSize,
  CustomVariableBlot,
  DividerBlot,
  EmbedlyBlot,
  Font,
  Indent,
  InlineImageBlot,
  LetterSpacing,
  LineHeight,
  LinkBlot,
  ListItemBlot,
  Mention,
  Size,
];
